/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sub_Quotas_Save_SuccessInputs */



/**
* | output |
* | --- |
* | "Saved {count} change(s)." |
*
* @param {Sub_Quotas_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_save_success = /** @type {((inputs: Sub_Quotas_Save_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Save_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Änderung(en) gespeichert.`)
	return /** @type {LocalizedString} */ (`Saved ${i?.count} change(s).`)
});